import React, { createContext, useEffect, useState } from 'react';
import { PLACE_DEFAULT, SOURCE_DEFAULT, SMILES_BASE_URL } from '@/config';

import useApi from '@/hooks/useApi';

import { getPriority } from '@/services/requests/Priority';
import { TPriorityResponse } from '@/services/requests/Priority/types';
import { handleLogsOnPriorityRequest } from '@/services/requests/Recommendation/RecommendationLogs';

import { getUuid } from '@/helpers/StringHelper/uuid';

import { TProfileProps, TProfileContextProps, TProfileState } from './types';

const profileContextState = {
  profiles: [] as TPriorityResponse[],
  channel: 'web',
  place: PLACE_DEFAULT,
  smilesBaseUrl: SMILES_BASE_URL,
  source: SOURCE_DEFAULT,
};

export const ProfileContext = createContext({} as TProfileContextProps);

const ProfileProvider = ({
  place,
  source,
  channel,
  children,
  smilesBaseUrl,
}: TProfileProps) => {
  const { Api, setTraceId } = useApi();

  const [profile, setProfile] = useState<TProfileState>(profileContextState);
  const [isLoading, setIsLoading] = useState(true);

  const getLayoutByRecommendationId = (RecommendationId: string) => {
    const profileItem = profile.profiles.find(
      item => item.id === RecommendationId,
    );
    return profileItem?.layout || '1';
  };

  const loadingData = async () => {
    try {
      const requestId = getUuid();
      setTraceId(requestId);

      const result = await getPriority(Api, channel, place, requestId);
      handleLogsOnPriorityRequest(channel, place);

      if (result && Array.isArray(result)) {
        setProfile(prevState => ({
          ...prevState,
          profiles: result,
          place,
          channel,
          smilesBaseUrl,
          source,
        }));
        setIsLoading(false);
      } else {
        throw new Error('Not found priorities.');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <ProfileContext.Provider
      value={{
        profile,
        setProfile,
        getLayoutByRecommendationId,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export default ProfileProvider;
